<script setup>
import { h, ref, computed, onMounted, watch, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { usePermissionStore } from '@/store/modules/permission'
import { findByIdTree } from '@/utils/index'

const router = useRouter()
const route = useRoute()
const permissionStore = usePermissionStore()

const selectedKeys = ref([])
const openKeys = ref([])
const menuItems = ref([])

// 从 store 获取菜单数据
const menus = computed(() => permissionStore.getMenus)

watch(() => route.path, (newVal) => {
  const obj = findByIdTree(menus.value, newVal, 'uri')
  if (obj) {
    selectedKeys.value = [obj.id]
  }
})

watch(menus, (newVal) => {
  console.log('menu', newVal)

  menuItems.value = newVal.map((menu, index) => {
    openKeys.value.push(menu.id)
    if (menu.children && menu.children.length > 0) {
      // 有子菜单的情况
      return {
        key: menu.uri,
        title: menu.title,
        id: menu.id,
        children: menu.children.map(child => ({
          key: child.uri,
          title: child.title,
          id: child.id
        }))
      }
    } else {
      // 没有子菜单的情况
      return {
        key: menu.uri,
        title: menu.title,
        id: menu.id
      }
    }
  })

  nextTick(() => {
    const obj = findByIdTree(newVal, route.path, 'uri')
    if (obj) {
      selectedKeys.value = [obj.id]
    }
  })
}, { immediate: true  }, { deep: true })

function onClickMenu(info){
   // 查找匹配的对象
  let matchedObj = null;
  
  for (const menu of menuItems.value) {
    // 如果当前菜单项的id匹配
    if (menu.id === info.key) {
      matchedObj = menu;
      break;
    }
    
    // 如果有子菜单，检查子菜单中是否有匹配的id
    if (menu.children && menu.children.length > 0) {
      const matchedChild = menu.children.find(child => child.id === info.key);
      if (matchedChild) {
        matchedObj = matchedChild;
        break;
      }
    }
  }
  selectedKeys.value = [info.key]
  router.push(matchedObj.key)
  console.log('点击的菜单项:', selectedKeys.value, matchedObj)
}

// 组件挂载时，如果有缓存的菜单数据，则使用缓存数据
onMounted(() => {
  const cachedLoginInfo = localStorage.getItem('userLoginInfo')
  if (cachedLoginInfo && !menus.value.length) {
    try {
      const loginData = JSON.parse(cachedLoginInfo)
      permissionStore.setLoginInfo(loginData)
    } catch (error) {
      console.error('解析缓存的登录信息失败:', error)
    }
  }
})
</script>

<template>
  <div class="sider">
    <div class="logo-area">跳绳小凡赛事系统</div>
    <a-menu
      theme="dark"
      mode="inline"
      v-model:selectedKeys="selectedKeys"
      v-model:openKeys="openKeys"
      @click="onClickMenu"
    >
      <!-- 动态渲染菜单 -->
      <template v-for="menu in menuItems" :key="menu.key">
        <a-sub-menu v-if="menu.children && menu.children.length > 0" :key="menu.id">
          <template #title>{{ menu.title }}</template>
          <a-menu-item 
            v-for="child in menu.children" 
            :key="child.id"
          >
            {{ child.title }}
          </a-menu-item>
        </a-sub-menu>
        <a-menu-item v-else :key="menu.id">
          {{ menu.title }}
        </a-menu-item>
      </template>
    </a-menu>
  </div>
</template>

<style scoped>
.sider{width:200px;min-height:100vh; background-color: #304156; color: #fff;}
.logo-area{height:48px;display:flex;align-items:center;padding:0 16px;font-weight:600;border-bottom:1px solid rgba(255,255,255,.1)}
:deep(.ant-menu-dark .ant-menu-item-selected){background-color: transparent; color: #409EFF;}
:deep(.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):active){background-color: #304156;}

:deep(.ant-menu-dark) {
  background-color: #304156;
}

:deep(.ant-menu-dark.ant-menu-inline .ant-menu-sub.ant-menu-inline) {
  background: #1f2d3d;
}

:deep(.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-submenu-title:active) {
  background: transparent;
}
</style>


